module.exports = __webpack_public_path__ + "img/重庆迎风湖国家湿地公园@2x.b961047c.png";